<template>
  <WebTop />
  <div id="body-wrap">

  <div class="home-block-title" style="margin-top: 24px;">
    <Icon type="ios-book-outline" color="#2d8cf0" /> <b style="color: #2d8cf0">咨询列表</b>
  </div>
  <List item-layout="vertical"  style="padding: 12px; border: solid 1px #dcdee2; border-top: none;">
    <ListItem v-for="item in workBriefings" :key="item.id">
      <ListItemMeta>
        <template #title><router-link :to="{path: '/question/show', query:{id: item.id}}"><b>{{ item.title }}</b></router-link></template>
        <!-- <template #description>{{ item.forumDesc }}</template> -->
      </ListItemMeta>
      <!--最新帖子：{{item.content}}-->
      <template #action>
        <li>
          <Icon type="ios-chatbubbles-outline" /> 作者 <b>{{ item.createUserName }}</b>
        </li>
        <li>
          <Icon type="ios-thumbs-up-outline" /> 提问日期 <b>{{ item.createTime }}</b>
        </li>
        <li>
          <Icon type="ios-chatbubbles-outline" /> 回复数量 <b>{{ item.answerNum }}</b>
        </li>
      </template>
    </ListItem>
  </List>
  <div id="pager"><Page :total="num" @on-change="pageChange" show-total /></div>


  
</div>

</template>
<script>
import WebTop from '../../components/WebTop.vue'
import global from '../../utils/global'
import axios from 'axios'
export default {
  components: {
    WebTop
  },
  data () {
    return {
      workBriefings:[],
      page: 1,
      num: 0
    }
  },
  mounted() {
    this.workBriefing()
  },
  methods: {
    workBriefing() {
      let vm = this
      axios({
        method: 'post',
        url: global.restUrl + '/api/web/ask/v1.0/question/list',
        data: {
          limit:10,
          page: vm.page
        }
      }).then(function (response) {
        let success = response.data.success
        if(success) {
          let data = response.data.data
          vm.workBriefings = data.list
          vm.num = data.num
        }
      });
    },
    pageChange(page) {
      this.page = page
      this.workBriefing()
    }
  }
}
</script>
